enum TrayCsvUploadStatusEnum {
  'Success',
  'Partial Success',
  'Fail',
  'PartialSuccess',
}

export default TrayCsvUploadStatusEnum;
